import { all } from 'redux-saga/effects';
import questionnaireSaga from './questionnaires.saga';

export default function * rootSaga() {
    yield all([questionnaireSaga()]);
}
